class ReorderModal extends HTMLElement {
    constructor() {
        super();
        if (!this.querySelector('.repeat-purchase')) return;

        this.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
        this.querySelector('button[type="submit"]').addEventListener('click', this.addOrder.bind(this));
        this.querySelectorAll('.button--reorder').forEach((button) => {
            button.addEventListener('click', this.addOrder.bind(this));
        });
        this.querySelectorAll('button[type="button"]').forEach((button) => {
            button.addEventListener('click', this.close.bind(this));
        });
    }

    connectedCallback() {
        if (!this.querySelector('.repeat-purchase')) return;
        if (
            localStorage.getItem('hideRepeatPurchase') != 'true' &&
            !window.location.href.includes('checkout') &&
            !window.location.href.includes('cart')
        ) {
            this.open();
        }
    }

    onBodyClick(event) {
        if (!this.contains(event.target) || event.target.classList.contains('reorder__overlay')) this.close(false);
    }

    addOrder(event) {
        event.preventDefault();
        const singleValue = event.target.getAttribute('data-line');
        const isSingle = singleValue ? true : false;

        if (!event.target.getAttribute('data-id')) {
            console.error(window.cartStrings.error);
            return;
        }

        const orderID = event.target.getAttribute('data-id');
        const itemsToAdd = isSingle
            ? [window.customerVariables.orders[orderID].line_items[singleValue]]
            : window.customerVariables.orders[orderID].line_items;

        fetch('cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                items: itemsToAdd,
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    console.error('Error:', response);
                    return;
                }
                localStorage.setItem('hideRepeatPurchase', 'true');
                sendAnalyticsEventData(USER_INTERACTION_ANALYTICS_EVENTS.repeatPurchase, {
                    action: 'Added',
                    context: 'Order Added',
                });
                window.location.href = routes.cart_url;
            })
            .catch((error) => {
                console.error('Error:', error);
                sendAnalyticsEventData(USER_INTERACTION_ANALYTICS_EVENTS.repeatPurchase, {
                    action: 'Error',
                    context: 'Order Add Failed',
                });
            });
    }

    open() {
        this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
        this.setAttribute('open', true);
        document.body.addEventListener('click', this.onBodyClickEvent);
        document.body.classList.add('overflow-hidden');
    }

    close(focusToggle = true) {
        localStorage.setItem('hideRepeatPurchase', 'true');
        removeTrapFocus(focusToggle ? this.summaryToggle : null);
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClickEvent);
        document.body.classList.remove('overflow-hidden');

        sendAnalyticsEventData(USER_INTERACTION_ANALYTICS_EVENTS.repeatPurchase, {
            action: 'Closed',
            context: 'Modal Closed',
        });
    }
}

customElements.define('repeat-purchase', ReorderModal);
